import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { modelData } from '../data/modelData';
import { ModelSectionRenderer } from '../components/ModelSectionRenderer';

const ModelDetail = () => {
    const { slug } = useParams();

    // Use the slug to find the model, or default to bj40-pro for now if testing without valid links
    const model = modelData[slug] || modelData['bj40-pro'];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);

    if (!model) {
        return <div>Model not found</div>;
    }

    return (
        <main className="min-h-screen bg-white pb-20">
            {/* Hero Section */}
            <section className="relative h-[80vh] min-h-[500px]">
                <div className="absolute inset-0">
                    <img
                        src={model.hero.image}
                        alt={model.hero.title}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://placehold.co/1920x1080';
                        }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent" />
                </div>

                <div className="relative z-10 flex h-full items-center px-6 md:px-12 max-w-7xl mx-auto">
                    <div className="text-white max-w-2xl">
                        <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-4">{model.hero.title}</h1>
                        <p className="text-xl md:text-2xl font-light tracking-widest uppercase border-l-4 border-red-600 pl-4">
                            {model.hero.subtitle}
                        </p>
                    </div>
                </div>
            </section>

            {/* Dynamic Sections */}
            <div className="space-y-12 mt-12">
                {model.sections.map((section, i) => (
                    <ModelSectionRenderer key={i} section={section} modelSlug={model.slug} />
                ))}
            </div>
        </main>
    );
};

export default ModelDetail;
